import * as image from '../../assets/index'

export const PROSPECTING_TOOLS_AUTHORIZED_ROLES = {
  packageRecommendation: [
    'admin',
    'clientcare',
    'leadconverter',
    'inside',
    'premise',
    'national',
    'reseller',
    'thryvonly',
    'tss',
    'yello',
    'premisedemo',
    'insidedemo',
    'premisepilot',
    'vivialdemo',
    'directsales',
    'partnerops',
  ],
  thryvDemoRequest: ['admin', 'premise', 'national'],
  thryvPaySavingsProposal: [
    'admin',
    'clientcare',
    'leadconverter',
    'inside',
    'premise',
    'national',
    'reseller',
    'thryvonly',
    'tss',
    'yello',
    'premisedemo',
    'insidedemo',
    'premisepilot',
    'vivialdemo',
    'australia',
    'directsales',
    'partnerops',
  ],
  thryvLeads: [
    'admin',
    'clientcare',
    'leadconverter',
    'inside',
    'premise',
    'national',
    'reseller',
    'thryvonly',
    'tss',
    'premisedemo',
    'insidedemo',
    'premisepilot',
    'vivialdemo',
    'directsales',
    'partnerops',
  ],
  thryvCSN: [
    'admin',
    'clientcare',
    'leadconverter',
    'inside',
    'premise',
    'national',
    'thryvonly',
    'tss',
    'premisedemo',
    'insidedemo',
    'premisepilot',
    'vivialdemo',
    'directsales',
    'partnerops',
  ],
  seoMBGProposal: [
    'admin',
    'clientcare',
    'leadconverter',
    'inside',
    'premise',
    'national',
    'thryvonly',
    'tss',
    'premisedemo',
    'insidedemo',
    'premisepilot',
    'vivialdemo',
    'australia',
  ],
  seoProposal: [
    'admin',
    'clientcare',
    'leadconverter',
    'inside',
    'premise',
    'national',
    'thryvonly',
    'tss',
    'premisedemo',
    'insidedemo',
    'premisepilot',
    'vivialdemo',
    'australia',
    'reseller',
    'keappartner',
  ],
}

/**
 * @typedef {{
 *   title: string;
 *   image: string;
 *   type: 'link' | 'modal';
 *   url: string;
 *   requiredRoles?: string[];
 *   hidden?: boolean;
 * }} ToolData
 */

/**
 * @type {Array<ToolData>}
 */
export const EDUCATION_AND_DEMOS = [
  {
    type: 'link',
    title: 'Global Learning Resources',
    url: 'https://collateral.thryv.info/learning-hub-navigation',
    image: image.globalLearningHubLogo,
  },
  {
    type: 'modal',
    title: 'Thryv Marketing Center Demos',
    url: 'marketing-center-demos',
    image: image.marketingCenterDemoLogo,
    requiredRoles: [
      'admin',
      'leadconverter',
      'premisepilot',
      'reseller',
      'insidedemo',
      'premise',
      'national',
      'tss',
      'australia',
      'newzealandsales',
      'inside',
      'premisedemo',
      'clientcare',
      'partnerops',
    ],
  },
  {
    type: 'modal',
    title: 'Thryv Business Center Demos',
    url: 'business-center-demos',
    image: image.businessCenterDemoLogo,
  },
  {
    type: 'modal',
    title: 'Thryv Command Center Demos',
    url: 'command-center-demos',
    image: image.commandCenterDemosIcon,
  },
  {
    type: 'link',
    title: 'Thryv Support Center',
    url: 'https://learn.thryv.com/hc/en-us',
    image: image.supportCenter,
  },
  {
    type: 'modal',
    title: 'Thryv Reporting Center Demos',
    url: 'reporting-center-demos',
    image: image.thryvReportingCenterDemosIcon,
  },
  {
    type: 'modal',
    title: 'ThryvPay Demos',
    url: 'thryvpay-demos',
    image: image.thryvPayDemoLogo,
  },
  {
    type: 'modal',
    title: 'Thryv Marketplace Demos',
    url: 'marketplace-demos',
    image: image.marketplaceDemosIcon,
  },
  {
    type: 'link',
    title: 'Thryv Specialties',
    url: 'http://industries.thryv.info/',
    image: image.specialitiesLogo,
    hidden: true,
    requiredRoles: [
      'admin',
      'clientcare',
      'leadconverter',
      'inside',
      'premise',
      'national',
      'reseller',
      'thryvonly',
      'tss',
      'yello',
      'premisedemo',
      'insidedemo',
      'premisepilot',
      'vivialdemo',
    ],
  },
  {
    type: 'modal',
    title: 'Thryv Workforce Center Demos',
    url: 'workforce-center-demos',
    image: image.workforceCenterLogo,
  },
]

/**
 * @typedef {{
 *   title: string;
 *   image: string;
 *   type: 'link' | 'modal';
 *   url: string;
 *   requiredRoles?: string[];
 *   hidden?: boolean;
 * }} ToolData
 */

/**
 * @type {Array<ToolData>}
 */
export const SALES_AND_SUPPORT_MATERIALS = [
  {
    type: 'link',
    title: 'Product at a Glance',
    url: 'https://thryv.sharepoint.com/:x:/s/ProductMarketing/ETKE6A05KK9BuoAnnvCcMjUBkROONLfROtyH0vow9xw-Pg?e=dtYEdX&wdLOR=c1C52DCD3-8831-9E48-9364-6CFB829A0B0EConnect%20your%20OneDrive%20account',
    image: image.ProductAtGlance,
  },
  {
    type: 'modal',
    title: 'Product Leave Behinds',
    url: 'product-leave-behinds',
    image: image.leaveBehindsIcon,
  },
  {
    type: 'modal',
    title: 'Other Leave Behinds',
    url: 'other-leave-behinds',
    image: image.otherLeaveBehinds,
  },
  {
    type: 'modal',
    title: 'Local Ads (US)',
    url: 'local-ads',
    image: image.localAdsIcon,
  },
  // {
  //   type: 'modal',
  //   title: 'Client Testimonials',
  //   url: 'testimonials',
  //   redirectUrl:
  //     'https://thryv.sharepoint.com/teams/TheLearningHub/SitePages/Client-Testimonials.aspx',
  //   image: image.testimonial,
  // },
  {
    type: 'link',
    title: 'Webinar',
    url: 'https://collateral.thryv.info/webinars',
    image: image.webinarIcon,
  },
  {
    type: 'modal',
    title: 'Benchmarking Tool',
    url: 'https://tsabenchmarks.sandbox.thryv.com/',
    image: image.benchmarkingToolIcon,
  },
]
